import React from "react";
import { StyledFooter } from "./FooterTH.styled";

const FooterTH: React.FC = () => {
  return (
    <StyledFooter className="garena-footer">
      <div className="container">
        <div className="bottom">
          <div className="logos" />
          <div className="cnt">
            <div className="copyrights">
              Copyright © Garena Online. Trademarks belong to their respective
              owners. All Rights Reserved. Copyright © Riot Games, Inc.
              &quot;Riot Games&quot; and &quot;League of Legends&quot; are
              trademarks, service marks and/or registered trademarks throughout
              the world. All rights reserved.
            </div>
            <div className="social-links">
              <a href="https://lol.garena.in.th/" className="playForFree">
                เล่นฟรี
              </a>
              <div className="links">
                <a
                  href="https://www.facebook.com/th.lol"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="link"
                >
                  <div className="link-txt">Facebook</div>
                </a>
                <a
                  href="https://www.youtube.com/user/LoLPlayinter"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="link"
                >
                  <div className="link-txt">YouTube</div>
                </a>
                <a
                  href="https://www.garena.co.th/tos"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="link"
                >
                  <div className="link-txt">Terms of Service</div>
                </a>
                <a
                  href="https://www.garena.co.th/privacy"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="link"
                >
                  <div className="link-txt">Privacy policy</div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </StyledFooter>
  );
};

export default FooterTH;
